import styled, { isCanvasTheme } from 'foundations-theming/utils';
export const StyledLoadingButton = styled.div.withConfig({
  displayName: "NextButtonstyles__StyledLoadingButton"
})(({
  theme,
  disabled
}) => ({
  button: Object.assign({
    minHeight: '3rem',
    padding: '12px 8px',
    lineHeight: '20px !important',
    fontSize: '16px !important',
    fontWeight: '500 !important',
    whiteSpace: 'normal',
    width: '100%'
  }, !disabled && isCanvasTheme(theme) && {
    backgroundColor: '#ff5c35 !important',
    borderColor: '#ff5c35 !important',
    '&:hover': {
      backgroundColor: '#ff6c49 !important',
      borderColor: '#ff6c49 !important'
    }
  }, isCanvasTheme(theme) && {
    '&[data-loading-state="loading"], &[data-loading-state="success"]': {
      backgroundColor: '#ff5c35 !important',
      borderColor: '#ff5c35 !important',
      '&:hover': {
        backgroundColor: '#ff6c49 !important',
        borderColor: '#ff6c49 !important'
      }
    }
  }, disabled && {
    color: `${theme.color['text-core-subtle']} !important`
  })
}));